import { render, staticRenderFns } from "./mc-icon.vue?vue&type=template&id=3b0cfbec&scoped=true&"
import script from "./mc-icon.ts?vue&type=script&lang=ts&"
export * from "./mc-icon.ts?vue&type=script&lang=ts&"
import style0 from "./mc-icon.scss?vue&type=style&index=0&id=3b0cfbec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0cfbec",
  null
  
)

export default component.exports